import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

// See https://github.com/szimek/signature_pad
// And https://edupala.com/how-to-add-angular-signature-pad/
@Component({
  selector: 'app-signature',
  template: `
    <div #parentdiv style="width:100%">
      <label>Signature:</label>
      <canvas [width]="width" [height]="height" class="my-canvas" #canvas></canvas>
    </div>
    <button style="margin-top: 5px" color="primary" type="button" mat-raised-button (click)="clear()">
      Clear
    </button>
  `,
  styles: [
    `
      .my-canvas {
        display: block;
        border: 3px solid rgba(82, 63, 105, 0.06);
        border-radius: 5px;
        background-color: rgb(255, 255, 255);
      }
    `
  ]
})
export class SignatureComponent implements OnInit, AfterViewInit {
  signaturePad: SignaturePad;
  @ViewChild('canvas') canvasEl: ElementRef;
  signatureImg: string;
  canvas: any;
  @ViewChild('parentdiv') parentdivEl: ElementRef;
  width: number;
  height: number;

  constructor() {
  }

  ngOnInit(): void {
    this.width = 200;
    this.height = 100;
  }

  ngAfterViewInit() {
    this.width = this.parentdivEl.nativeElement.offsetWidth - 5;
    this.height = this.width / 2;
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement, {
      minWidth: 0.5, // of line 0.5
      maxWidth: 2.5, // of line 2.5
      penColor: 'black',
      backgroundColor: 'rgb(255, 255, 255)'
    });
    this.canvas = this.canvasEl.nativeElement;
    // window.addEventListener('resize', this.throttle(() => this.resizeCanvas, 500));
  }

  // UNUSED
  resizeCanvas() {
    console.log("Resize canvas because of resize");
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvas.width = this.canvas.offsetWidth * ratio;
    this.canvas.height = this.canvas.offsetHeight * ratio;
    this.canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  }

  clear() {
    this.signaturePad.clear();
  }

  // SEE https://stackoverflow.com/a/51493084
  throttle(callback, delay) {
    let timeoutHandler = null;
    return () => {
      if (timeoutHandler == null) {
        timeoutHandler = setTimeout(() => {
          callback();
          timeoutHandler = null;
        }, delay);
      }
    };
  }

  // Unused
  debounce(callback, delay) {
    let timeoutHandler = null;
    return () => {
      clearTimeout(timeoutHandler);
      timeoutHandler = setTimeout(() => {
        callback();
      }, delay);
    };
  }

  returnImage() {
    return this.signaturePad.toDataURL('image/png'); // save image as JPEG
  }

  done() {
    return !this.signaturePad.isEmpty();
  }

}
